"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapInitialState = exports.MADRID_COORDS = exports.AMSTERDAM_COORDS = exports.DEFAULT_COUNTRY = exports.ClusterPointType = exports.COLORS = void 0;
// Colors
exports.COLORS = {
    white: '#fff',
    blue: '#2677FF',
    orange: '#d87303',
    green: '#16BE42',
    pathColor: '#1f5b29',
    notConnectedPathColor: '#6f7474',
    darkGreen: 'rgba(114, 164, 32, 1)',
    arrowColor: 'white',
};
// We arrange things into clusters, later we know which type are
var ClusterPointType;
(function (ClusterPointType) {
    ClusterPointType[ClusterPointType["Stops"] = 0] = "Stops";
    ClusterPointType[ClusterPointType["Steps"] = 1] = "Steps";
    ClusterPointType[ClusterPointType["Locations"] = 2] = "Locations";
})(ClusterPointType = exports.ClusterPointType || (exports.ClusterPointType = {}));
exports.DEFAULT_COUNTRY = 'Netherlands';
exports.AMSTERDAM_COORDS = { lat: 52.3545653, lng: 4.7585401 };
exports.MADRID_COORDS = { lat: 40.4378698, lng: -3.8196222 };
exports.mapInitialState = {
    // Just default, required some default data but will be soon overriden.
    center: exports.AMSTERDAM_COORDS,
    zoom: 8,
};
